import EntityMemberCommand, {
  EntityMemberCommandPayload,
} from "_shared/entity-members/_api/commands/entity-member-api-command";
import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";

export type WorkTeamAPIRequestPayload = {
  leader?: EntityMemberCommandPayload;
  members?: EntityMemberCommandPayload[];
  marketplaceId?: string;
};

export default class WorkTeamAPICommand {
  leader?: EntityMemberCommand;
  members?: EntityMemberCommand[];
  marketplaceId?: string;

  public static fromTeam(team: VendorTeam): WorkTeamAPICommand {
    if (!team.leader) {
      throw new Error("no team leader on WorkTeamAPICommand");
    }

    return Object.assign(new WorkTeamAPICommand(), {
      leader: new EntityMemberCommand(team.leader),
      members: team.members.map((member) => new EntityMemberCommand(member)),
      marketplaceId: team.marketplaceId?.value,
    });
  }

  public get payload(): object {
    return {
      leader: this.leader?.payload,
      members: this.members?.map((member) => member.payload),
      marketplaceId: this.marketplaceId,
    };
  }
}
